import React, { useState } from 'react'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { UncontrolledTooltip } from '../../../components/reactstrap'

const isDev = process.env.NODE_ENV !== 'production'

const Menu = ({
  onClickDelete,
  onClickEdit,
  onClickForceImport,
  onClickForceReImport,
  role,
  state = null
}) => {
  const { t } = useTranslation(['ProjectsPage', 'commons'])
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <Dropdown
      isOpen={isOpen}
      name="menu"
      toggle={toggle}
    >
      <DropdownToggle nav className="p-0">
        <div className="vertical-triple-dots" />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          disabled={['pending', 'importing'].includes(state)}
          name="edit"
          onClick={() => onClickEdit()}
        >
          {t('buttons.edit', { ns: 'commons' })}
        </DropdownItem>
        <DropdownItem
          disabled={['pending', 'importing'].includes(state)}
          className="text-danger"
          name="remove"
          onClick={() => onClickDelete()}
        >
          {t('buttons.remove', { ns: 'commons' })}
        </DropdownItem>

        {role === 'admin' && (
          <>
            <DropdownItem divider />
            <DropdownItem
              disabled={['pending', 'importing'].includes(state)}
              name="force_import"
              id="force_import"
              onClick={() => onClickForceImport()}
            >
              {t('buttons.force_import', { ns: 'commons' })}
            </DropdownItem>
            <UncontrolledTooltip placement="right" target="force_import">
              {t('Menu.tooltip.forceImport')}
            </UncontrolledTooltip>

            {isDev && (
              <DropdownItem
                className="text-danger"
                disabled={['pending', 'importing'].includes(state)}
                name="force_reimport"
                onClick={() => onClickForceReImport()}
              >
                {t('buttons.force_reimport', { ns: 'commons' })}
              </DropdownItem>
            )}
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  )
}

Menu.propTypes = {
  onClickDelete: PropTypes.func.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickForceImport: PropTypes.func.isRequired,
  onClickForceReImport: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  state: PropTypes.string
}

const mapStateToProps = ({
  authentication: {
    role
  }
}) => ({
  role
})

export default connect(mapStateToProps)(Menu)
